module.exports = __webpack_public_path__ + "static/media/data-collection.1b610752.svg";